// extracted by mini-css-extract-plugin
export default {"ordersList":"styles_ordersList__l+8QC","header":"styles_header__zb55B","button":"styles_button__VfL8f","orders":"styles_orders__g2ph2","headerTitle":"styles_headerTitle__0eKlS"};